import Vue from 'vue';

/**
 * Array of all possible weight classes
 * Key is weight in LBS and representation in database
 */
Vue.prototype.$weightClasses = function () {
  return [
    {
      genders: ['f'],
      maxKg: 47.6,
      stringDe: 'Atomgewicht [-47,6 kg]',
      stringEn: 'Atomweight [-105 lbs]',
      titleDe: 'Atomgewicht',
      titleEn: 'Atomweight',
      weight: 105,
    },
    {
      genders: ['f', 'm'],
      maxKg: 52.2,
      stringDe: 'Strohgewicht [-52,2 kg]',
      stringEn: 'Strawweight [-115 lbs]',
      titleDe: 'Strohgewicht',
      titleEn: 'Strawweight',
      weight: 115,
    },
    {
      genders: ['f', 'm'],
      maxKg: 56.7,
      stringDe: 'Fliegengewicht [-56,7 kg]',
      stringEn: 'Flyweight [-125 lbs]',
      titleDe: 'Fliegengewicht',
      titleEn: 'Flyweight',
      weight: 125,
    },
    {
      genders: ['f', 'm'],
      maxKg: 61.2,
      stringDe: 'Bantamgewicht [-61,2 kg]',
      stringEn: 'Bantamweight [-135 lbs]',
      titleDe: 'Bantamgewicht',
      titleEn: 'Bantamweight',
      weight: 135,
    },
    {
      genders: ['f', 'm'],
      maxKg: 65.8,
      stringDe: 'Federgewicht [-65,8 kg]',
      stringEn: 'Featherweight [-145 lbs]',
      titleDe: 'Federgewicht',
      titleEn: 'Featherweight',
      weight: 145,
    },
    {
      genders: ['f', 'm'],
      maxKg: 70.3,
      stringDe: 'Leichtgewicht [-70,3 kg]',
      stringEn: 'Lightweight [-155 lbs]',
      titleDe: 'Leichtgewicht',
      titleEn: 'Lightweight',
      weight: 155,
    },
    {
      genders: ['m'],
      stringDe: 'Weltergewicht [-77,1 kg]',
      stringEn: 'Welterweight [-170 lbs]',
      titleDe: 'Weltergewicht',
      titleEn: 'Welterweight',
      maxKg: 77.1,
      weight: 170,
    },
    {
      genders: ['m'],
      maxKg: 83.9,
      stringDe: 'Mittelgewicht [-83,9 kg]',
      stringEn: 'Middleweight [-185 lbs]',
      titleDe: 'Mittelgewicht',
      titleEn: 'Middleweight',
      weight: 185,
    },
    {
      genders: ['m'],
      maxKg: 93.0,
      stringDe: 'Halbschwergewicht [-93,0 kg]',
      stringEn: 'Light-Heavyweight [-205 lbs]',
      titleDe: 'Halbschwergewicht',
      titleEn: 'Light-Heavyweight',
      weight: 205,
    },
    {
      genders: ['m'],
      maxKg: 120.2,
      stringDe: 'Schwergewicht [-120,2 kg]',
      stringEn: 'Heavyweight [-265 lbs]',
      titleDe: 'Schwergewicht',
      titleEn: 'Heavyweight',
      weight: 265,
    },
    {
      genders: ['m'],
      maxKg: 200.0,
      stringDe: 'Super-Schwergewichtgewicht [+120,2 kg]',
      stringEn: 'Super-Heavyweight [+265 lbs]',
      titleDe: 'Super-Schwergewicht',
      titleEn: 'Super-Heavyweight',
      weight: 300,
    },
  ];
};

/**
 * Returns array of all female weight classes
 */
Vue.prototype.$weightClassesFemale = function () {
  return this.$weightClasses.filter((wc) => wc.genders.includes('f'));
};

/**
 * Returns array of all male weight classes
 */
Vue.prototype.$weightClassesMale = function () {
  return this.$weightClasses.filter((wc) => wc.genders.includes('m'));
};
